import { PullDownContent, PullToRefresh, ReleaseContent } from 'react-js-pull-to-refresh';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Redux/Store';
import { AppContext } from '../../Context/AppContext';
import { useAppDispatch, useAppSelector } from '../../Hooks/Hooks';
import { getMyLoadsData } from '../../Redux/Reducers/MyLoadsSlice';
import { scrollIntoView } from '../../Utils/Basic';
import { deleteCookie, getCookie } from '../../Utils/CookieUtils';
import { getLoadCount, getLoads } from '../../Utils/MyLoads.utils';
import { getAllShipmentsRequestPayload } from '../../Utils/APIRequestsPlayloads';
import { COOKIE_IDS, PULL_TO_REFRESH } from '../../Constants/Constants';
import ResultContainer from '../../Components/ResultContainer/ResultContainer';
import './Loads.scss';

const Loads = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobile } = useContext(AppContext);
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { myLoadsData, myLoadsSectionSelectedTab } = useAppSelector((state: RootState) => {
    return state?.myLoads;
  });
  const showBanner = useAppSelector((state: RootState) => state.ContentOrConfig?.showBanner);

  useEffect(() => {
    if (!isMobile) navigate('/myloads');
  }, [isMobile, navigate]);

  useEffect(() => {
    const loadId = getCookie(COOKIE_IDS.SHIPMENT_ID);
    if (loadId) {
      scrollIntoView(loadId);
      deleteCookie(COOKIE_IDS.SHIPMENT_ID);
    }
  }, []);

  const onRefresh = () => {
    return new Promise((resolve) => {
      const callback = () => {
        resolve(null);
      };
      const driverId = memberData?.member?.userApplicationDetails?.[0].attributes.DriverId;
      if (driverId)
        myLoadsSectionSelectedTab?.forEach((item: any) => {
          if (item.selected) {
            const requestPayload = getAllShipmentsRequestPayload(driverId, item.slug, 0);
            dispatch(getMyLoadsData({ requestPayload, hideLoader: true, callback }));
          }
        });
    });
  };

  return (
    <div className={`Loads ${showBanner ? ' AlertBannerVisible' : ''}`}>
      <div className="Load_List">
        <PullToRefresh
          pullDownContent={<PullDownContent label="" />}
          releaseContent={<ReleaseContent label="" />}
          refreshContent={
            <div>
              <img
                src="/oo/assets/images/Schneider_Spinner-transparent.gif"
                alt=""
                className="PullToRefresh-Loader"
              />
            </div>
          }
          pullDownThreshold={PULL_TO_REFRESH.THRESHOLD}
          onRefresh={onRefresh}
          triggerHeight={PULL_TO_REFRESH.TRIGGER_HEIGHT}
          backgroundColor="#e8e5e1"
          startInvisible={true}
        >
          <div>
            {myLoadsSectionSelectedTab?.map((item: any) => {
              if (item.selected) {
                const isRecentlyDeliveredLoad = item.slug === 'Delivered' || false;
                return (
                  <ResultContainer
                    label="My Loads"
                    totalRecords={getLoadCount(item.slug, myLoadsData)}
                    loadPostings={getLoads(item.slug, myLoadsData)}
                    isMyLoads={true}
                    isRecentlyDelivered={isRecentlyDeliveredLoad}
                  />
                );
              }
              return null;
            })}
          </div>
        </PullToRefresh>
      </div>
    </div>
  );
};

export default Loads;
